import type { ApiQuestionSetting } from '../../../../internalTypes/apiQuestionSetting';

export type CfmMatrixScaleControl = 'RADIO' | 'SLIDER';

function readScaleControlValue(value: string | undefined): CfmMatrixScaleControl | undefined {
  const normalized = value?.trim().toUpperCase();
  if (normalized === 'SLIDER') return 'SLIDER';
  if (normalized === 'RADIO') return 'RADIO';
  return undefined;
}

/** Bipolar scale control from MATRIX_TYPE.childConfigs.MATRIX_FORMAT or top-level MATRIX_FORMAT. */
export function resolveCfmMatrixFormat(
  configs: ApiQuestionSetting[],
): CfmMatrixScaleControl | undefined {
  const matrixTypeConfig = configs.find(c => c.key === 'MATRIX_TYPE');
  const nested = matrixTypeConfig?.childConfigs?.find(c => c.key === 'MATRIX_FORMAT');
  const nestedControl = readScaleControlValue(nested?.value?.[0]);
  if (nestedControl) return nestedControl;

  const topLevel = configs.find(c => c.key === 'MATRIX_FORMAT');
  return readScaleControlValue(topLevel?.value?.[0]);
}
